/**
 * Transmission Direction
 */
export enum TransmissionDirection {
  /**
   * Send
   */
  Sent = 'sent',

  /**
   * Received
   */
  Received = 'received',
}
